export default __webpack_public_path__ + "static/media/techflow.b83470af.png";